import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { AddPortCallCoordinationsTab } from './coordinations';

import { PortCallScheduleHeaderView } from 'portcall/portcallschedule/view';
import { SelectCoordinationsView } from 'portcall/selectcoordinations/view';

export const AddPortCallCoordinationsTabView = SuperCritical(({ model: m } : { model : AddPortCallCoordinationsTab }) =>
    <div className="addportcallcoordinationstab">
        <PortCallScheduleHeaderView className="schedule-header" model={m.ScheduleHeader} />
        <SelectCoordinationsView model={m.SelectCoordinations} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/coordinationsview.tsx